import Common    from './common'
import Promotion from './promotion'

export default {
  Common   : Common,
  Promotion: Promotion,
}
